module.exports = __webpack_public_path__ + "src-notif-expedia.png?d49993280b91f3ec059f54d1bea5fa7b";